<!-- <lib1-shared-comp [configsForAppPassedIn]="configsForApp"></lib1-shared-comp> -->
<nxt-app1-header></nxt-app1-header>

<!-- to handle tab close events for login out on tab close  -->
<lib1-shared-handler></lib1-shared-handler>

<div *ngIf="isLoggedIn">

  <lib1-msgs-to-user></lib1-msgs-to-user>

  <router-outlet></router-outlet>

  <div *ngIf="showLoadingIndicator"
       class="spinner"></div>

</div>

<div *ngIf="!isLoggedIn"
     style="text-align: center; font-size: 40px;">

  <b>This is App1 <br />Need to login</b>

</div>

<div style="text-align: center; font-size: 40px;">
  environment name: {{configsForApp.envName}}
</div>


<!-- <a href="{{app2Url}}">App 2</a> -->

<!-- <a href="~/app2/index.html">App 2</a> -->
<br/>

<a href="{{app2Url}}"
   class="btn btn-info"
   role="button">Go to app 2</a>